import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const initScrollProgressBar = () => {
    const progressBar = document.querySelector('.js-progress')
    const progressCircle = document.querySelector('.js-progress-circle')

    // Layouts zonder scroll-rail (bv. de scan) hebben deze elementen niet
    if (!progressBar || !progressCircle) {
        return
    }

    gsap.to(progressBar, {
        height: '100%',
        ease: 'none', // no ease, we control smoothness with the 'scrub' property
        scrollTrigger: {
            start: 0,
            end: 'max',
            scrub: 0.5
        }
    })

    const setRotation = gsap.quickSetter(progressCircle, 'rotation', 'deg')
    const degPerPx = 0.2

    ScrollTrigger.create({
        start: 0,
        end: 'max',
        onUpdate(self) {
            gsap.to(progressCircle, {
                rotation: self.scroll() * degPerPx,
                duration: 0.15,
                ease: 'none',
                overwrite: true
            })
        }
    })

    setTimeout(() => {
        ScrollTrigger.refresh()
    }, 1000)
}

// Initialize Scroll Progress Bar
document.addEventListener('DOMContentLoaded', () => {
    initScrollProgressBar()
})
